import { useCallback, useEffect, useRef } from 'react'

import { hooks } from '@front/volcanion'

import Callbacks from './callbacks'

const useHandlingIncident = () => {
  const { closeNotification, openNotification } = hooks.useNotification()

  const notif_path = hooks.useCDNAsset('notif', 'sound', { extension: 'wav' })

  const [, searchIncident] = hooks.useModelSearch('event', 'get')
  const desktopNotifications = useRef({})

  const openLocalNotification = useCallback(
    Callbacks.openLocalNotificationHandler(openNotification),
    [openNotification]
  )
  const openDesktopNotification = useCallback(
    Callbacks.openDesktopNotificationHandler(searchIncident, desktopNotifications, closeNotification),
    [searchIncident, desktopNotifications, closeNotification]
  )
  const closeDesktopNotification = useCallback(
    Callbacks.closeDesktopNotificationHandler(desktopNotifications),
    [desktopNotifications]
  )
  const playAudio = useCallback(
    Callbacks.playAudioHandler(notif_path),
    [notif_path]
  )

  useEffect(() => {
    if ('Notification' in window && Notification.permission !== "denied")
      Notification.requestPermission()
  }, [])

  hooks.useSocketEvent('incident_created', useCallback(async ({ event_id }) => {
    await openLocalNotification(event_id)
    await openDesktopNotification(event_id)
    await playAudio()
  }, [openLocalNotification, openDesktopNotification, playAudio]))

  hooks.useSocketEvent('incident_complete', useCallback(({ event_id }) => {
    closeNotification(event_id)
    closeDesktopNotification(event_id)
  }, [closeNotification, closeDesktopNotification]))
}

export { useHandlingIncident }
